export interface ArticleDetail {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  date: string;
  readTime: string;
  views: number;
  image: string;
  content: { type: 'paragraph' | 'heading' | 'list'; text?: string; items?: string[] }[];
  tags: string[];
  relatedArticles: { id: number; title: string; image: string }[];
}

export const articleDetails: Record<number, ArticleDetail> = {
  1: {
    id: 1,
    title: '2025年国产美妆品牌TOP10排行榜，谁是真正的国货之光？',
    category: '国产美妆',
    categorySlug: 'meizhuang',
    date: '2025-08-01',
    readTime: '8分钟',
    views: 12580,
    image: 'https://readdy.ai/api/search-image?query=Top%2010%20Chinese%20domestic%20beauty%20brand%20products%20elegantly%20displayed%20on%20a%20minimalist%20white%20shelf%20with%20soft%20warm%20lighting%2C%20editorial%20product%20photography%2C%20clean%20cream%20background&width=1200&height=500&seq=article-detail-1&orientation=landscape',
    content: [
      { type: 'paragraph', text: '随着国货美妆品牌的崛起，越来越多的消费者开始将目光从国际大牌转向国产化妆品。从花西子的东方美学到完美日记的潮流设计，从薇诺娜的功效护肤到毛戈平的专业彩妆，国产美妆品牌正以惊人的速度成长，不仅在品质上媲美国际大牌，在价格上也更加亲民。' },
      { type: 'heading', text: '评选标准' },
      { type: 'paragraph', text: '本次评选我们综合考量了以下五个维度：产品品质与安全性、品牌口碑与用户评价、产品创新能力、性价比表现以及品牌文化与社会影响力。每个维度满分20分，总分100分。' },
      { type: 'heading', text: 'TOP10榜单' },
      { type: 'paragraph', text: '第一名：花西子（97分）——以"东方彩妆，以花养妆"为品牌理念，将中国传统工艺与现代彩妆技术完美融合。其雕花口红系列成为现象级产品，雕花工艺精美绝伦，使用体验也极为出色。' },
      { type: 'paragraph', text: '第二名：完美日记（94分）——作为新生代国货彩妆的代表品牌，完美日记以时尚的设计、丰富的产品线和亲民的价格迅速占领市场。其"小细跟"口红系列凭借独特包装设计和优质使用感受，成为年轻消费者的心头好。' },
      { type: 'paragraph', text: '第三名：薇诺娜（93分）——专为敏感肌研发的国产功效护肤品牌，拥有多项专利技术和临床验证数据。其舒敏保湿特护霜是敏感肌用户的"救命稻草"，在产品功效和安全性方面获得了广泛认可。' },
      { type: 'paragraph', text: '第四名：毛戈平（91分）——由国内顶级化妆师毛戈平创立的专业彩妆品牌，以高遮瑕粉膏闻名。产品品质对标国际一线品牌，在专业彩妆领域具有极高的口碑。' },
      { type: 'paragraph', text: '第五名：珀莱雅（89分）——深耕护肤品领域多年，近年来凭借"双抗精华"等明星产品实现了品牌焕新。产品研发投入大，在抗衰老领域取得了显著突破。' },
      { type: 'heading', text: '行业趋势洞察' },
      { type: 'paragraph', text: '从本次榜单可以看出，国产美妆品牌正在经历从"平价替代"到"品牌自信"的转型。越来越多的国货品牌开始注重研发投入、品牌建设和文化表达，不再简单地定位为国际大牌的平替，而是以自身独特的产品力和品牌价值赢得消费者。' },
      { type: 'paragraph', text: '未来，随着Z世代成为消费主力，国货美妆品牌需要更加注重产品创新、可持续发展和社会责任。那些能够在品质、设计和品牌文化上持续突破的品牌，将有机会成为真正的"国货之光"。' },
    ],
    tags: ['国产美妆', '品牌排行', '花西子', '完美日记', '国货推荐'],
    relatedArticles: [
      { id: 5, title: '国产护肤品成分党指南：看懂这些成分，选对国产好货', image: 'https://readdy.ai/api/search-image?query=Chinese%20skincare%20ingredients%20displayed%20scientifically%2C%20minimalist%20cream%20background%2C%20educational%20photography&width=400&height=250&seq=related-art-5&orientation=landscape' },
      { id: 101, title: '国货口红横评：花西子vs完美日记vs毛戈平，哪支最值得买？', image: 'https://readdy.ai/api/search-image?query=Three%20Chinese%20lipsticks%20comparison%2C%20minimalist%20cream%20background%2C%20beauty%20photography&width=400&height=250&seq=related-art-101&orientation=landscape' },
    ],
  },
  2: {
    id: 2,
    title: '国产手机崛起：从追随者到领跑者的蜕变之路',
    category: '国产数码',
    categorySlug: 'shuma',
    date: '2025-07-28',
    readTime: '10分钟',
    views: 9870,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20smartphone%20brands%20evolution%20displayed%20as%20creative%20visual%20timeline%2C%20modern%20tech%20aesthetic%2C%20cream%20background%2C%20editorial&width=1200&height=500&seq=article-detail-2&orientation=landscape',
    content: [
      { type: 'paragraph', text: '十年前，"国产手机"还是低端和山寨的代名词。而今天，华为、小米、OPPO、vivo等品牌已经在全球市场占据了举足轻重的地位。这场从追随者到领跑者的蜕变，是中国科技产业崛起的缩影，也是无数工程师和企业家共同努力的结果。' },
      { type: 'heading', text: '第一阶段：模仿跟随（2008-2013）' },
      { type: 'paragraph', text: '这一时期，国产手机主要以功能机和低端智能机为主，在设计和功能上大量借鉴国际品牌。但正是在这个阶段，国产手机厂商积累了供应链管理、产品设计和市场营销的基础经验。小米的诞生标志着互联网手机模式的开创，以极致性价比策略迅速打开市场。' },
      { type: 'heading', text: '第二阶段：技术追赶（2014-2018）' },
      { type: 'paragraph', text: '华为自研麒麟芯片的成功，标志着国产手机进入技术追赶阶段。各品牌纷纷加大研发投入，在摄影、快充、屏幕等核心领域取得突破。华为P系列和Mate系列在高端市场站稳脚跟，OPPO和vivo在线下渠道建立起强大的竞争力。' },
      { type: 'heading', text: '第三阶段：创新引领（2019至今）' },
      { type: 'paragraph', text: '折叠屏、屏下摄像头、超级快充、计算摄影……国产手机品牌在多个技术领域已经走在了全球前列。华为的影像技术、小米的充电技术、OPPO的折叠屏设计，都在引领行业发展方向。尽管面临外部环境的挑战，国产手机品牌依然展现出强大的韧性和创新力。' },
      { type: 'heading', text: '未来展望' },
      { type: 'paragraph', text: 'AI手机、卫星通信、全场景智慧生态……国产手机品牌正在打开新的想象空间。随着5G、AI、IoT技术的深度融合，国产手机将不仅仅是通讯工具，而是成为智慧生活的核心枢纽。' },
    ],
    tags: ['国产手机', '华为', '小米', '科技创新', '行业发展'],
    relatedArticles: [
      { id: 201, title: '华为Mate 70 Pro深度评测：国产手机的巅峰之作', image: 'https://readdy.ai/api/search-image?query=Huawei%20smartphone%20on%20desk%2C%20minimalist%20cream%20background%2C%20tech%20product%20photography&width=400&height=250&seq=related-art-201&orientation=landscape' },
      { id: 6, title: '智能穿戴设备选购指南：国产手表和手环哪个更适合你？', image: 'https://readdy.ai/api/search-image?query=Smartwatches%20displayed%20on%20surface%2C%20minimalist%20cream%20background%2C%20product%20photography&width=400&height=250&seq=related-art-6&orientation=landscape' },
    ],
  },
  3: {
    id: 3,
    title: '国潮新食尚：这些国产零食品牌正在重新定义中国味道',
    category: '国产食品',
    categorySlug: 'shipin',
    date: '2025-07-25',
    readTime: '7分钟',
    views: 7340,
    image: 'https://readdy.ai/api/search-image?query=Colorful%20Chinese%20domestic%20snacks%20arranged%20beautifully%2C%20warm%20lighting%2C%20cream%20background%2C%20food%20photography&width=1200&height=500&seq=article-detail-3&orientation=landscape',
    content: [
      { type: 'paragraph', text: '从三只松鼠的坚果到良品铺子的高端零食，从元气森林的无糖气泡水到王饱饱的烘焙麦片，国产零食品牌正在以全新的面貌出现在消费者面前。它们不仅在产品品质上精益求精，更在品牌文化、包装设计和营销方式上不断创新，重新定义了"中国味道"。' },
      { type: 'heading', text: '零食三巨头的差异化竞争' },
      { type: 'paragraph', text: '三只松鼠以IP化和娱乐化的品牌形象走红，凭借可爱的松鼠形象和有趣的品牌故事迅速占领年轻人市场。良品铺子则走高端零食路线，强调原料品质和产品创新，在高端零食细分领域建立了强大的品牌认知。百草味以"让更多人吃上健康的食品"为使命，在坚果和果干品类中建立了自己的优势。' },
      { type: 'heading', text: '新锐品牌的崛起' },
      { type: 'paragraph', text: '元气森林用"0糖0脂0卡"的概念颠覆了传统饮料市场，成为新一代健康饮品的代名词。王饱饱将"超级食物"概念引入早餐麦片，打造了烘焙麦片这一全新品类。ffit8以蛋白棒切入健康代餐市场，瞄准健身和轻食人群。' },
      { type: 'heading', text: '传统零食的国潮复兴' },
      { type: 'paragraph', text: '在国潮风的推动下，许多传统中国零食也焕发了新生。蛋黄酥、鲜花饼、小麻花、核桃酥等传统点心通过包装升级和口味创新，成为年轻人追捧的网红零食。这些传统零食的复兴，不仅是商业的成功，更是中国饮食文化的自信表达。' },
    ],
    tags: ['国产零食', '三只松鼠', '良品铺子', '元气森林', '国潮美食'],
    relatedArticles: [
      { id: 301, title: '三只松鼠vs良品铺子vs百草味：三大国产零食品牌深度对比', image: 'https://readdy.ai/api/search-image?query=Three%20snack%20brands%20packaging%20comparison%2C%20minimalist%20cream%20background&width=400&height=250&seq=related-art-301&orientation=landscape' },
      { id: 302, title: '国产健康食品品牌盘点：从元气森林到王饱饱', image: 'https://readdy.ai/api/search-image?query=Health%20food%20beverage%20products%2C%20minimalist%20cream%20background%2C%20lifestyle%20photography&width=400&height=250&seq=related-art-302&orientation=landscape' },
    ],
  },
  4: {
    id: 4,
    title: '国潮服饰品牌全解析：李宁、安踏们如何让中国设计走向世界',
    category: '国产服饰',
    categorySlug: 'fushi',
    date: '2025-07-20',
    readTime: '9分钟',
    views: 6120,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20fashion%20brands%20clothing%20displayed%20creatively%2C%20editorial%20fashion%20photography%2C%20cream%20background&width=1200&height=500&seq=article-detail-4&orientation=landscape',
    content: [
      { type: 'paragraph', text: '2018年，李宁以"悟道"系列亮相纽约时装周，一时间"中国李宁"四个字成为社交媒体的热搜词。这不仅是一场秀的成功，更是国潮服饰品牌集体崛起的标志性事件。从李宁到安踏，从波司登到鄂尔多斯，国产品牌正以自信的姿态走向世界舞台。' },
      { type: 'heading', text: '李宁：国潮先锋，文化自信的旗帜' },
      { type: 'paragraph', text: '李宁品牌的转型是国潮崛起的最佳注脚。从传统运动品牌到融合中国文化和潮流设计的"中国李宁"，品牌通过设计创新和文化表达，成功实现了品牌年轻化和高端化。韦德之道系列篮球鞋更是在专业运动领域赢得了全球认可。' },
      { type: 'heading', text: '安踏：多品牌战略的全球化布局' },
      { type: 'paragraph', text: '安踏通过收购FILA中国业务和始祖鸟母公司Amer Sports，构建了覆盖大众运动、时尚运动和高端户外的多品牌矩阵。在产品科技方面，安踏的氮科技中底等自主研发技术已经达到国际领先水平。' },
      { type: 'heading', text: '中国设计师品牌的国际化之路' },
      { type: 'paragraph', text: '在国际时装周上，UMA WANG、ANGEL CHEN、RUI ZHOU等中国设计师品牌正在用独特的东方美学和国际化的设计语言赢得全球时尚界的关注。他们不追求简单的"中国元素"堆砌，而是从文化内核出发，创造出具有普世价值的当代设计。' },
    ],
    tags: ['国潮服饰', '李宁', '安踏', '中国设计', '时尚潮流'],
    relatedArticles: [
      { id: 401, title: '李宁vs安踏：两大国产运动品牌的产品力全面对决', image: 'https://readdy.ai/api/search-image?query=Sportswear%20brands%20comparison%2C%20minimalist%20cream%20background%2C%20product%20photography&width=400&height=250&seq=related-art-401&orientation=landscape' },
      { id: 402, title: '国潮设计师品牌推荐：这8个中国原创设计品牌值得关注', image: 'https://readdy.ai/api/search-image?query=Designer%20fashion%20clothing%2C%20minimalist%20cream%20background%2C%20fashion%20photography&width=400&height=250&seq=related-art-402&orientation=landscape' },
    ],
  },
  5: {
    id: 5,
    title: '国产护肤品成分党指南：看懂这些成分，选对国产好货',
    category: '国产美妆',
    categorySlug: 'meizhuang',
    date: '2025-07-15',
    readTime: '12分钟',
    views: 15230,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20skincare%20ingredients%20displayed%20scientifically%2C%20minimalist%20cream%20background%2C%20educational%20photography&width=1200&height=500&seq=article-detail-5&orientation=landscape',
    content: [
      { type: 'paragraph', text: '随着成分党文化的兴起，越来越多的消费者开始关注护肤品中的有效成分。国产护肤品牌也在成分研发上不断加码，从传统的草本提取到现代的生物科技，国产护肤品的成分实力已经今非昔比。' },
      { type: 'heading', text: '明星成分解析' },
      { type: 'paragraph', text: '玻尿酸（透明质酸）：华熙生物是全球最大的玻尿酸原料供应商，国产护肤品在玻尿酸应用方面具有天然优势。润百颜、夸迪等品牌的产品中使用了多种分子量的玻尿酸，实现了深层补水和表层锁水的双重效果。' },
      { type: 'paragraph', text: '烟酰胺（维生素B3）：珀莱雅的"双抗精华"中含有的烟酰胺成分，具有提亮肤色、控油、修复肌肤屏障等多重功效。国产护肤品在烟酰胺的配方稳定性方面做了大量研究。' },
      { type: 'paragraph', text: '视黄醇（维生素A）：薇诺娜、HBN等品牌在视黄醇的抗衰老应用中取得了显著成果，通过包裹技术和缓释系统降低了视黄醇的刺激性。' },
      { type: 'heading', text: '选购建议' },
      { type: 'paragraph', text: '在选择国产护肤品时，建议关注产品的成分表和研发背景。正规品牌的产品都会在国家药监局进行备案，可以通过官方渠道查询。同时，不要盲目追求高浓度成分，适合自己的才是最好的。' },
    ],
    tags: ['护肤品成分', '玻尿酸', '烟酰胺', '成分党', '护肤指南'],
    relatedArticles: [
      { id: 1, title: '2025年国产美妆品牌TOP10排行榜，谁是真正的国货之光？', image: 'https://readdy.ai/api/search-image?query=Beauty%20brands%20top%2010%2C%20minimalist%20cream%20background%2C%20editorial&width=400&height=250&seq=related-art-1b&orientation=landscape' },
      { id: 102, title: '敏感肌救星：国产药妆品牌薇诺娜深度评测', image: 'https://readdy.ai/api/search-image?query=Dermatological%20skincare%2C%20minimalist%20cream%20background%2C%20clinical%20photography&width=400&height=250&seq=related-art-102&orientation=landscape' },
    ],
  },
  6: {
    id: 6,
    title: '智能穿戴设备选购指南：国产手表和手环哪个更适合你？',
    category: '国产数码',
    categorySlug: 'shuma',
    date: '2025-07-10',
    readTime: '8分钟',
    views: 5890,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20smartwatches%20and%20fitness%20bands%20comparison%2C%20modern%20tech%20aesthetic%2C%20cream%20background%2C%20product%20photography&width=1200&height=500&seq=article-detail-6&orientation=landscape',
    content: [
      { type: 'paragraph', text: '智能手表和智能手环已经成为很多人日常生活的必备品。华为、小米、OPPO等国产品牌在智能穿戴领域推出了多款优秀产品，但面对琳琅满目的选择，如何找到最适合自己的那一款？' },
      { type: 'heading', text: '智能手表 vs 智能手环：核心差异' },
      { type: 'paragraph', text: '智能手表功能更全面，通常支持独立通话、安装应用、GPS导航等功能，但续航较短，通常1-3天。智能手环功能相对精简，以健康监测和消息通知为主，但续航可达7-14天，价格也更加亲民。' },
      { type: 'heading', text: '热门产品推荐' },
      { type: 'paragraph', text: '华为Watch GT系列：续航出色，健康监测专业，适合注重健康和运动追踪的用户。小米手环系列：性价比极高，基础功能齐全，适合第一次尝试智能穿戴的用户。OPPO Watch系列：设计时尚，支持eSIM独立通话，适合追求潮流和便捷的用户。' },
      { type: 'paragraph', text: '最终选择建议：如果你需要独立通话、安装应用等高级功能，建议选择智能手表；如果你主要关注健康监测和消息通知，智能手环已经完全够用，而且价格更实惠。' },
    ],
    tags: ['智能穿戴', '华为手表', '小米手环', '选购指南', '数码产品'],
    relatedArticles: [
      { id: 2, title: '国产手机崛起：从追随者到领跑者的蜕变之路', image: 'https://readdy.ai/api/search-image?query=Smartphone%20evolution%2C%20minimalist%20cream%20background%2C%20tech%20editorial&width=400&height=250&seq=related-art-2b&orientation=landscape' },
      { id: 203, title: '国产TWS耳机选购指南：2025年最值得买的5款国产真无线耳机', image: 'https://readdy.ai/api/search-image?query=Wireless%20earbuds%2C%20minimalist%20cream%20background%2C%20product%20photography&width=400&height=250&seq=related-art-203&orientation=landscape' },
    ],
  },
};

export const allArticles = Object.values(articleDetails);